import i18n from '@/i18n/index';
import { columns } from '@/services/import/logoDispositif/templateLogoDispositif';
import store from '@/store/store';
import { getAll, UpdateAllLogo } from '@/api/gabed/dispositif';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import genenrerLogoDispositif from '@/services/import/logoDispositif/genererLogoDispositif';

export function ErrorLogoDispositifTranslate(errors) {
  if (!errors || !Array.isArray(errors)) return [];

  return errors.map(error => {
    if (error.endsWith('_IS_REQUIRED')) {
      return i18n.t('importationLogoDispositif.errors.requiredPropertie', { label: error.split('_')[0] });
    }
    if (error.startsWith('DISPOSITIF_NOT_FOUND')) {
      return i18n.t('importationLogoDispositif.errors.dispositifNotFound', { code: error.split('@')[1] });
    }
    return 'Problème Survenu';
  }).join(' - ');
}

function validationLigne(ligne, dispositif, errors) {
  columns.forEach(column => {
    const columnErrors = column.checkValue(ligne[column.key]);
    if (columnErrors.length > 0) {
      columnErrors.forEach(error => {
        errors.push({ errors: [error], numLigne: ligne.numLigne });
      });
    }
  });
  if (!!ligne.codeDispositif && (dispositif === null || dispositif === undefined)) {
    errors.push({ errors: [`DISPOSITIF_NOT_FOUND@${ligne.codeDispositif}`], numLigne: ligne.numLigne });
  }
}

export async function makeLogoDispositifGenerated(file) {
  const logos = [];
  const data = [];
  const errors = [];
  const codes = [];

  for (let i = 1; i < file[0].length; i += 1) {
    const ligne = file[0][i];
    data.push(ligne);
    if (ligne.codeDispositif !== undefined) {
      codes.push(ligne.codeDispositif);
    }
  }

  if (data.length === 0) return [];

  const dispositifs = (await getAll({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      codes: codes,
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  for (let i = 0; i < data.length; i += 1) {
    const dispositif = dispositifs.find(d => d.code === data[i].codeDispositif);
    const nbError = errors.length;
    validationLigne(data[i], dispositif, errors);
    if (nbError === errors.length) {
      const newLogo = genenrerLogoDispositif(data[i]);
      logos.push(newLogo);
    }
  }
  if (errors.length > 0) throw errors;
  return logos;
}

export async function makeLogoDispositifImport(data, modeTest) {
  // Diviser les données en lots de 100 éléments
  for (let i = 0; i < data.length; i += 100) {
    // Créer un lot de 100 éléments (ou moins pour le dernier lot)
    const batch = data.slice(i, i + 100);
    const payload = {
      codeDispositifLogo: batch,
      modeTest: modeTest,
    };

    // Attendre que chaque lot soit traité
    // eslint-disable-next-line no-await-in-loop
    await UpdateAllLogo(payload);
  }
}
